/* UNSCRIPTED 60-second recall test, part 3 of 4: result page, in-page claim, navigation, optional review mode (?review=1), start. */

function revealHtml() {
  const parts = [];
  if (st.sInfo) {
    let c = "";
    for (let i = 0; i < CELLS; i++) {
      const name = st.sInfo.items.find(n => st.sInfo.where[n] === i);
      if (!name) { c += `<div class="cell">${NB}</div>`; continue; }
      const ok = st.sInfo.picks[name] === i;
      c += `<div class="cell item ${ok ? "right" : "miss"}">${name}<small>${ok ? "&#10003; right" : "&#10007; missed"}</small></div>`;
    }
    parts.push(`<p><b>Positions:</b> ${st.sScore} of 6 correct.</p><div class="grid">${c}</div>`);
  }
  if (st.dInfo) parts.push(`<p><b>Number:</b> you saw</p><div class="seqline">${st.dInfo.seq.join(" ")}</div><p>and keyed in</p><div class="seqline">${st.dInfo.typed.join(" ")}</div>`);
  return parts.join("") || "<p>Your answers are shown here after you take the full test.</p>";
}

/* The claim box (snippets/unscripted-free-offer) is rendered once by the template into #offer-src and moved into the result page.
   mount() would destroy it when the screen changes, so park it back first. */
const _mount = mount;
mount = function (html, focus) {
  const box = document.querySelector("#screen .um-free"), park = document.getElementById("offer-src");
  if (box && park) park.appendChild(box);
  return _mount(html, focus);
};
function shopRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/"; }

/* Claim: the top and sticky buttons press the claim box's own button, so one code path adds the cart lines, shows the digital add-on
   popups and then opens the cart panel (assets/unscripted-recall-e.js). */
let viaTop = false;
function claim(pos) {
  const btn = document.querySelector("#offerslot [data-um-free-cta]");
  track("quiz_claim_click", { position: pos, quiz_score: habit() + st.sScore + st.dScore });
  if (btn && !btn.disabled) { viaTop = true; btn.click(); viaTop = false; }
}

function result() {
  const h = habit(), s = st.sScore, d = st.dScore, total = h + s + d;
  const key = typeKey(h, s + d), ty = TYPES[key];
  const focus = pickVal("q4") || "names and faces";
  if (!st.resultSeen) { st.resultSeen = true; track("quiz_result_view", { quiz_score: total, quiz_type: key, habit: h, spatial: s, digits: d }); }
  say("Your baseline score is " + total + " out of 18. " + ty.name + ".");

  const meter = Array.from({ length: 18 }, (_, i) => `<i class="${i < total ? "on" : ""}"></i>`).join("");
  const trickHtml = st.trick
    ? `<div class="panel" id="exp"><h3>Your experiment</h3><p>Three new items, each with a place: <b>${st.trick.correct} of 3</b> correct. A second try can improve on its own, so treat this as your own test. The manual teaches the full version: ten stations in a room you know.</p></div>`
    : `<details class="panel" id="exp"><summary>Optional: a 20-second experiment</summary><p>Spatial memory gets easier when each item has a place. Try it on three new items.</p><button class="cta ghost" id="trybtn" type="button">Try the trick</button></details>`;

  mount(`
    <section>
      <div class="rhead">
        <p class="eyebrow">Your baseline score &middot; Day 0</p>
        <div class="rscore"><b>${total}</b><span>/ 18</span></div>
        <div class="meter" role="img" aria-label="${total} out of 18">${meter}</div>
        <h1 class="rtype">${ty.name}</h1>
        <p class="rline">${ty.line} Retake after Day 30 and compare.</p>
      </div>

      <button class="cta" type="button" data-pos="top">Claim my free manual</button>
      <p class="micro" style="margin-bottom:18px">Just cover shipping. Cost shown at checkout.<br>Use the same email at checkout and your Day 0 sheet and coach access arrive straight away.</p>

      <div class="panel">
        <h3>What your answers suggest</h3>
        <div class="bars">
          <div class="bar"><div class="lab"><span>Recall habits</span><span>${h} / 6</span></div><div class="track"><div class="fill" data-w="${h / 6 * 100}"></div></div></div>
          <div class="bar"><div class="lab"><span>Positions</span><span>${s} / 6</span></div><div class="track"><div class="fill" data-w="${s / 6 * 100}"></div></div></div>
          <div class="bar"><div class="lab"><span>Number</span><span>${d} / 6</span></div><div class="track"><div class="fill" data-w="${d / 6 * 100}"></div></div></div>
        </div>
        <p>${ty.diag}</p>
      </div>

      <div class="panel plan">
        <div class="lbl">Your plan</div>
        <dl class="planrows">
          <div><dt>Start with</dt><dd><b>${ty.start.where}</b>${ty.start.why}</dd></div>
          <div><dt>Hold first</dt><dd><b>Your ${focus}</b>Use them as the first facts you place.</dd></div>
          <div><dt>Each day</dt><dd><b>15 minutes each morning for 30 days</b>Day 30 ends with a retest, so you can compare against today.</dd></div>
        </dl>
      </div>

      <div id="offerslot"></div>

      ${trickHtml}

      <details class="panel">
        <summary>Your answers</summary>
        <div class="rev">${revealHtml()}</div>
      </details>

      <details class="panel">
        <summary>Why this works</summary>
        <p>In one study, people recalled less of what they were told a computer would save for them. When a device keeps a fact, we tend to keep less of it ourselves.</p>
        <p class="src2">Sparrow, Liu and Wegner, Science, 2011.</p>
        <p>The part of memory you can train on purpose is spatial. In one study, adults who trained a memory-palace method for 40 days went from about 26 to about 62 of 72 words.</p>
        <p class="src2">Dresler et al., Neuron, 2017. A study result, not a promise of yours.</p>
      </details>

      <p class="fine" style="margin-top:14px">A short self-check and memory test, not a medical test.</p>
      <div style="text-align:center"><button class="link" id="retake" type="button">Retake the test</button></div>
    </section>`, "h1");

  /* Move the claim box into the page */
  const slot = document.getElementById("offerslot"), box = document.querySelector("#offer-src .um-free");
  if (slot && box) slot.appendChild(box);
  /* Carry the result onto the cart, so it reaches the order */
  try {
    fetch(shopRoot() + "cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: { quiz_funnel: FUNNEL.slug, quiz_score: total + "/18", quiz_type: key, quiz_focus: focus, offer_entry: "recall_test" } }) });
  } catch (e) {}

  requestAnimationFrame(() => requestAnimationFrame(() => $screen.querySelectorAll(".fill").forEach(f => { f.style.width = f.dataset.w + "%"; })));
  const tb = document.getElementById("trybtn"); if (tb) tb.addEventListener("click", () => go("trick"));
  document.getElementById("retake").addEventListener("click", reset);

  /* Sticky claim bar: shows when neither the top button nor the claim box is on screen */
  const a = document.querySelector('[data-pos="top"]'), b = slot;
  const vis = { top: true, offer: false };
  $shell.classList.add("has-sticky");
  if ("IntersectionObserver" in window && a && b) {
    io = new IntersectionObserver(es => { es.forEach(e => { vis[e.target === a ? "top" : "offer"] = e.isIntersecting; }); $sticky.hidden = vis.top || vis.offer; }, { threshold: 0.2 });
    io.observe(a); io.observe(b);
  }
}

function reset() { Object.assign(st, { ans: {}, sInfo: null, dInfo: null, sScore: 0, dScore: 0, done: false, trick: null, resultSeen: false }); go("splash"); }

/* ---------- Navigation and clicks ---------- */
$back.addEventListener("click", () => { const b = BACK[st.id]; if (b) go(b); });
document.addEventListener("keydown", e => {
  if (e.metaKey || e.ctrlKey || e.altKey || e.target.tagName === "SELECT") return;
  if (st.keyHandler && (/^\d$/.test(e.key) || e.key === "Backspace")) { st.keyHandler(e.key); return; }
  if (Q[st.id]) { const n = parseInt(e.key, 10); if (n >= 1 && n <= Q[st.id].opts.length) choose(st.id, n - 1); }
});
document.addEventListener("click", e => {
  const p = e.target.closest && e.target.closest("[data-pos]");
  if (p) { claim(p.dataset.pos); return; }
  if (!viaTop && e.target.closest && e.target.closest("[data-um-free-cta]")) track("quiz_claim_click", { position: "offer", quiz_score: habit() + st.sScore + st.dScore });
});

/* ---------- Review mode: add ?review=1 to see test shortcuts, the headline swap and the events fired ---------- */
function buildReview() {
  const box = document.getElementById("review"); if (!box) return;
  box.hidden = false;
  box.innerHTML = '<b>Review mode.</b> Shortcuts for testing. Scores still come from answers.<div class="row" id="jumps"></div><div class="row"><label for="entry">Ad entry point:</label><select id="entry">' + Object.keys(HOOKS).map(k => `<option value="${k}"${k === st.entry ? " selected" : ""}>${k.toUpperCase()}</option>`).join("") + '</select></div><ol id="evl"></ol>';
  const jumps = document.getElementById("jumps");
  const addBtn = (label, fn) => { const b = document.createElement("button"); b.type = "button"; b.textContent = label; b.addEventListener("click", fn); jumps.appendChild(b); };
  const P = { Outsourcer: [{ q1: 0, q2: 0, q3: 0, q4: 0 }, 1, 0], Navigator: [{ q1: 0, q2: 1, q3: 0, q4: 1 }, 5, 4], Willing: [{ q1: 2, q2: 1, q3: 2, q4: 2 }, 1, 1], Keeper: [{ q1: 2, q2: 2, q3: 2, q4: 3 }, 5, 5] };
  addBtn("Test 1", () => { st.done = false; go("spatial"); });
  addBtn("Test 2", () => { st.done = false; go("digits"); });
  addBtn("Email step", () => { st.unlocked = false; st.done = true; go("gate"); });
  Object.entries(P).forEach(([n, p]) => addBtn(n, () => { st.ans = { ...p[0] }; st.sScore = p[1]; st.dScore = p[2]; st.sInfo = null; st.dInfo = null; st.done = true; st.trick = null; st.resultSeen = false; go("result"); }));
  addBtn("Restart", reset);
  document.getElementById("entry").addEventListener("change", e => { st.entry = e.target.value; if (st.id === "splash") splash(); });
  setInterval(() => { const l = document.getElementById("evl"); if (l) l.innerHTML = EVLOG.slice(-12).map(x => "<li>" + x.replace(/</g, "&lt;") + "</li>").join(""); }, 800);
}
if (/[?&]review=1\b/.test(location.search)) buildReview();

/* ---------- Start ---------- */
try { history.replaceState({ id: "splash" }, "", ""); } catch (e) {}
go("splash", true);